export { default as Index } from "./components/Main";
export type { IndexProps } from "./components/Main";
export { default as IndexPreview } from "./components/Preview";
